(() => {
  const YT_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i;
  const VIMEO_RE = /vimeo\.com\/(?:video\/)?(\d+)/i;

  function youtubeId(url) {
    const match = String(url || '').match(YT_RE);
    return match ? match[1] : null;
  }

  function vimeoId(url) {
    const match = String(url || '').match(VIMEO_RE);
    return match ? match[1] : null;
  }

  function sortGrid(grid) {
    if (!grid) return;
    const items = Array.from(grid.children);
    if (!items.some((item) => item.dataset.sort)) return;
    items
      .sort((a, b) => Number(a.dataset.sort || 999) - Number(b.dataset.sort || 999))
      .forEach((item) => grid.appendChild(item));
  }

  function ensureModal(root) {
    return root.querySelector('[data-how-to-modal]');
  }

  function closeModal(modal) {
    if (!modal) return;
    const player = modal.querySelector('[data-how-to-player]');
    if (player) player.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('m-how-to-modal-open');
  }

  function isPlayableUrl(url) {
    const value = String(url || '').trim();
    if (!value) return false;
    if (/^https?:\/\//i.test(value)) return true;
    if (youtubeId(value) || vimeoId(value)) return true;
    return false;
  }

  function openModal(modal, { url, title, poster }) {
    if (!modal || !url) return;
    const player = modal.querySelector('[data-how-to-player]');
    if (!player) return;

    if (!isPlayableUrl(url)) {
      // Filename placeholder still — wait until CDN/YouTube URL is pasted in Admin
      window.alert(`Video file not uploaded yet:\n${url}\n\nReplace video_url on the How To Video entry with the Shopify CDN or YouTube URL.`);
      return;
    }

    player.innerHTML = '';
    const yt = youtubeId(url);
    const vimeo = vimeoId(url);

    if (yt) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${yt}?autoplay=1&rel=0`;
      iframe.title = title || 'Video';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');
      player.appendChild(iframe);
    } else if (vimeo) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${vimeo}?autoplay=1`;
      iframe.title = title || 'Video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('frameborder', '0');
      player.appendChild(iframe);
    } else {
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'metadata';
      if (poster) video.poster = poster;
      video.src = url;
      player.appendChild(video);
    }

    modal.hidden = false;
    document.body.classList.add('m-how-to-modal-open');
  }

  function initRoot(root) {
    if (!root || root.dataset.howToReady === 'true') return;
    root.dataset.howToReady = 'true';

    sortGrid(root.querySelector('.m-page-how-to__grid'));
    sortGrid(root.querySelector('.m-how-to-guide__grid'));

    const modal = ensureModal(root);
    if (!modal) return;

    root.addEventListener('click', (event) => {
      const playBtn = event.target.closest('[data-how-to-play]');
      if (playBtn && root.contains(playBtn)) {
        event.preventDefault();
        openModal(modal, {
          url: playBtn.dataset.videoUrl,
          title: playBtn.dataset.videoTitle,
          poster: playBtn.dataset.posterUrl,
        });
        return;
      }

      if (event.target.closest('[data-how-to-close]')) {
        closeModal(modal);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal(modal);
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="page-how-to"], [data-section-type="how-to-guide"]')
      .forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector
      ? event.target.querySelector('[data-section-type="page-how-to"], [data-section-type="how-to-guide"]') ||
        (event.target.matches?.('[data-section-type="page-how-to"], [data-section-type="how-to-guide"]')
          ? event.target
          : null)
      : null;
    if (section) initRoot(section);
  });
})();
